/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Friends_Send_ToInputs */

const en_friends_send_to = /** @type {(inputs: Friends_Send_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recipients`)
};

const de_friends_send_to = /** @type {(inputs: Friends_Send_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empfänger`)
};

/**
* | output |
* | --- |
* | "Recipients" |
*
* @param {Friends_Send_ToInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const friends_send_to = /** @type {((inputs?: Friends_Send_ToInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Friends_Send_ToInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_friends_send_to(inputs)
	return en_friends_send_to(inputs)
});